import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle, AlertTriangle } from "lucide-react";

const money = (v, cur) => `${cur || "CAD"} $${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Outcome + total / paid / balance for a closed case (shared by the dialog and the case card). */
export function ClosingSummaryBody({ s }) {
  if (!s) return null;
  const unpaid = s.configured && Number(s.balance || 0) > 0;
  return (
    <div className="space-y-3" data-testid="closing-summary-body">
      <dl className="text-sm divide-y divide-slate-100">
        <Row label="Outcome" value={s.outcome} testid="cs-outcome" />
        {s.configured ? (
          <>
            <Row label={`Total fees${s.tax_exempt ? " (tax exempt)" : ""}`} value={money(s.total, s.currency)} testid="cs-total" />
            <Row label="Total paid" value={money(s.paid, s.currency)} testid="cs-paid" cls="text-emerald-600" />
            <Row label="Balance" value={money(s.balance, s.currency)} testid="cs-balance" cls={unpaid ? "text-rose-600 font-bold" : ""} />
          </>
        ) : (
          <>
            <Row label="Fees" value="Not configured" testid="cs-total" />
            <Row label="Total paid" value={money(s.paid, s.currency)} testid="cs-paid" />
          </>
        )}
        <Row label="Closed by" value={s.closed_by_name} testid="cs-by" />
      </dl>
      {unpaid && (
        <div data-testid="cs-unpaid" className="flex items-start gap-2 rounded-lg bg-rose-50 border border-rose-200 text-rose-800 text-xs px-3 py-2">
          <AlertTriangle className="h-4 w-4 shrink-0" /> This case closed with an unpaid balance.
        </div>
      )}
      <p className="text-[11px] text-slate-400">This summary was added to the client&apos;s notes.</p>
    </div>
  );
}

const Row = ({ label, value, testid, cls = "" }) => (
  <div className="flex justify-between gap-3 py-1.5"><dt className="text-slate-500">{label}</dt><dd data-testid={testid} className={`font-semibold text-slate-800 text-right ${cls}`}>{value}</dd></div>
);

export function ClosingSummaryDialog({ summary, onClose }) {
  return (
    <Dialog open={!!summary} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="closing-summary-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><CheckCircle className="h-5 w-5 text-emerald-600" /> Case closed</DialogTitle></DialogHeader>
        <ClosingSummaryBody s={summary} />
        <button data-testid="closing-summary-ok" onClick={onClose} className="w-full bg-primary text-white py-2.5 rounded-xl text-sm font-semibold">Done</button>
      </DialogContent>
    </Dialog>
  );
}

export { money as summaryMoney };
